import * as React from "react";
import styled from "styled-components";

/** ContactForm */
interface ContactFormProps {
  iframeSourceUrl: string
}

interface ContactFormState {}

class ContactForm extends React.Component<ContactFormProps,ContactFormState> {

  render() {
    const {iframeSourceUrl} = this.props;
    return (
      <ContactFormWrapper>
        <CardWrapper className="card">
          <IframeCardContentWrapper className="card-content white-text">
            <iframe
              title="Feedback Form"
              className="freshwidget-embedded-form"
              id="freshwidget-embedded-form"
              src={iframeSourceUrl}
              scrolling="no"
              height="590px"
              width="100%"
              frameBorder="0"
            />
          </IframeCardContentWrapper>
        </CardWrapper>
      </ContactFormWrapper>
    )
  }

}

/** STYLES */

/** CARD */

const ContactFormWrapper = styled.div`
  flex-basis: 50%;
`;

const CardWrapper = styled.div`
  flex-basis: 50%;
  overflow: visible !important;
`;

const IframeCardContentWrapper = styled.div`
  padding-bottom: 0px !important;
`;

export default ContactForm


// WEBPACK FOOTER //
// ./src/layouts/contact-form-block/contact-form.tsx